import { PurchaseStatus } from '@construction/shared';

/**
 * 采购「本工地」打开时默认落在哪个页签（CR-050）。
 *
 * 照 Expensify 按角色给快捷入口的做法：审批人先看到「待审批」，管理员先看到「待付款」。
 * - 能审批的人：有待批准 → 待批准；没有待批准、有待报销 → 待报销；都没有 → 全部记录（`null`）；
 * - 只看不批的人：全部记录 —— 待处理的页签对他只是看，不是事。
 *
 * `open` 是 summary 里不限日期的笔数。能审批、但还没拿到数时返回 `undefined`：先别落，
 * 落错一次再跳一次比多转一圈更让人迷糊。
 */
export function defaultPurchaseStatus(
  canReview: boolean,
  open: Partial<Record<string, { count: number }>> | undefined,
): PurchaseStatus | null | undefined {
  if (!canReview) return null;
  if (!open) return undefined;
  if ((open[PurchaseStatus.PENDING]?.count ?? 0) > 0) return PurchaseStatus.PENDING;
  if ((open[PurchaseStatus.APPROVED]?.count ?? 0) > 0) return PurchaseStatus.APPROVED;
  return null;
}
